type ServerMatch = {
  data: unknown;
  handle: unknown;
};

export function combinedServerComponentMatchesHandle<TProps>(
  // oxlint-disable-next-line typescript/no-explicit-any
  _matches: unknown[],
  handleProps?: TProps,
) {
  const matches = _matches as ServerMatch[];
  const combinedProps: Record<string, unknown> = { ...handleProps };

  for (const match of matches) {
    const matchHandle = match.handle ?? {};

    const matchLoaderDataHandle =
      match.data &&
      typeof match.data === 'object' &&
      'handle' in match.data &&
      typeof match.data.handle === 'object'
        ? match.data.handle
        : {};

    Object.assign(combinedProps, matchHandle, matchLoaderDataHandle);
  }

  return combinedProps as TProps;
}
